  <div class="container py-4 ">

    <!-- Page Header -->
    <header class="mb-4 ms-1">
      <p class="fw-bold mb-1 text-xl">Trust Reports</p>
      <p class="text-dark mb-3">Generate comprehensive trust reports for Founders and Trustees.</p>
    </header>

    <!-- Report Card -->
    <div class="glassy-table shadow-sm mb-4 rounded-lg px-2">
      <div class="card-body">

        <!-- Card Title -->
        <div class="d-flex align-items-center gap-2 mb-4">
          <i class="bi bi-bar-chart fs-4 text-primary"></i>
          <h2 class="h5 fw-bold mb-0">Generate New Report</h2>
        </div>

        <!-- Generator Content -->
        <div class="row g-4 mb-4">

          <!-- Report Period Selection -->
          <div class="col-md-4">
            <label class="form-label fw-semibold">Select Report Period</label>
            <div class="d-flex flex-column gap-2">
              <div
                class="card p-3 cursor-pointer shadow-sm"
                :class="{'border-success bg-success-subtle': selectedPeriod === 'Quarterly', 'border': selectedPeriod !== 'Quarterly'}"
                @click="selectedPeriod = 'Quarterly'"
              >
                <div class="d-flex align-items-center gap-2">
                  <i class="bi bi-calendar-event fs-4 text-success"></i>
                  <div>
                    <h3 class="h6 fw-bold mb-0">Quarterly</h3>
                    <p class="small text-muted mb-0">3-month period summary</p>
                  </div>
                </div>
              </div>

              <div
                class="card p-3 cursor-pointer shadow-sm"
                :class="{'border-success bg-success-subtle': selectedPeriod === 'Annual', 'border': selectedPeriod !== 'Annual'}"
                @click="selectedPeriod = 'Annual'"
              >
                <div class="d-flex align-items-center gap-2">
                  <i class="bi bi-graph-up fs-4 text-success"></i>
                  <div>
                    <h3 class="h6 fw-bold mb-0">Annual</h3>
                    <p class="small text-muted mb-0">Full year comprehensive report</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Inclusion List -->
          <div class="col-md-8">
            <label class="form-label fw-semibold">Report Will Include</label>
            <div class="d-flex flex-column gap-2">
              <div v-for="item in inclusionItems" :key="item.title" class="card p-2 d-flex flex-row align-items-center gap-2 bg-light shadow-sm">
                <div class="d-flex align-items-center justify-content-center rounded me-2" style="width:36px; height:36px; font-size:18px;">
                  <i
                    v-if="item.type === 'activity'" class="bi bi-activity text-primary"></i>
                  <i v-else-if="item.type === 'compliance'" class="bi bi-shield-check text-success"></i>
                  <i v-else-if="item.type === 'stakeholders'" class="bi bi-people text-info"></i>
                  <i v-else-if="item.type === 'risk'" class="bi bi-exclamation-triangle text-warning"></i>
                </div>
                <div>
                  <h3 class="h6 fw-bold mb-0">{{ item.title }}</h3>
                  <p class="small text-muted mb-0">{{ item.description }}</p>
                </div>
              </div>
            </div>
          </div>

        </div>

        <!-- Access Banner -->
        <div class="d-flex gap-3 p-3 bg-light rounded mb-4">
          <i class="bi bi-person-lines-fill fs-4 text-secondary"></i>
          <div>
            <strong class="d-block mb-1">Report Access</strong>
            <p class="small text-muted mb-0">
              Generated reports will be shared with the <strong>Founder</strong> and 
              <strong>Trustees</strong> only. A copy will be archived in Trust Documents 
              for long-term retention.
            </p>
          </div>
        </div>

        <!-- Action Footer -->
        <div class="d-flex justify-content-end">
          <button class="btn btn-primary-dark d-flex align-items-center gap-2 text-xs">
            Generate {{ selectedPeriod }} Report
          </button>
        </div>

      </div>
    </div>

  </div>